import {css} from "@emotion/css";

import {designColors} from "~/ui";
import {getHoverColor} from "~/utils/colors";

export const styles = {
  secondaryButton: css`
    &.MuiButton-root {
      &:hover {
        background-color: ${getHoverColor(designColors.white, "darker")};
      }
      &.Mui-focusVisible {
        box-shadow: inset 0 0 0 2px ${designColors.blue_3};
      }
      &.Mui-disabled {
        color: ${designColors.primary};
        opacity: 0.4;
      }
    }

    & .MuiLoadingButton-loadingIndicator {
      color: ${designColors.primary};
    }

    & .MuiTouchRipple-root span {
      background-color: ${getHoverColor(designColors.white, "lighter")};
      border-radius: 50%;

      opacity: 1 !important;
    }
  `,
};
